module.exports = __webpack_public_path__ + "static/media/Forretress_gaussian2.cb9214fa.png";